'use client';

import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';

import { cn } from '@balder/ui/lib/cn';

// font-semibold (upstream: font-medium) and `optional` are ours.
function Label({
  className,
  children,
  optional,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> & { optional?: boolean }) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'flex items-center gap-2 text-sm leading-none font-semibold select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
      {optional && <span className="text-muted-foreground text-xs font-light"> (optional)</span>}
    </LabelPrimitive.Root>
  );
}

export { Label };
